module.exports = __webpack_public_path__ + "static/media/50.a6052403.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/50.png
// module id = 475
// module chunks = 0